/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable, ReplaySubject} from 'rxjs';
import {UnsavedChangesService} from './unsaved-changes.service';
import {ConfirmModalGeneralComponent} from '../../confirm-modal/deprecated-modals/confirm-modal-general/confirm-modal-general.component';
import {ConfirmModalGeneralModel} from '../../confirm-modal/deprecated-modals/confirm-modal-general/confirm-modal-general.model';

@Injectable({
    providedIn: 'root'
})
export class UnsavedChangesGuard  {
    constructor(private service: UnsavedChangesService) {
    }

    canDeactivate(
            component: any,
            currentRoute: ActivatedRouteSnapshot,
            currentState: RouterStateSnapshot,
            nextState?: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        const hasChanges = this.service.isChanged();

        const canNavigate = new ReplaySubject<boolean>(1);

        if (!hasChanges || component.isExited) {
            canNavigate.next(true);
        } else if (hasChanges || Object.entries(this.service.current).length) {
            const confirmModalInstance: ConfirmModalGeneralComponent =
                    component.modalService.open(ConfirmModalGeneralComponent).componentInstance;
            confirmModalInstance.initModal({title: component.MODAL_TITLE} as ConfirmModalGeneralModel);
            confirmModalInstance.confirmEvent.subscribe((valueModal: any) => {
                canNavigate.next(valueModal);
            });
        }
        return canNavigate.asObservable();
    }
}
